<app-header />
<div class="main main-shell">
    <app-side-navigation />
    <section class="main-content">
        <div class="main-inner">
            <router-outlet></router-outlet>
        </div>
    </section>
    <div>
        <app-footer />
    </div>
</div>
